export type Lang = "en" | "zh";

export interface LocaleCopy {
  title: string;
  headline: string;
  kicker: string;
  lede: string;
  exploreHint: string;
  helpTitle: string;
  helpMove: string;
  helpLook: string;
  helpZoom: string;
  helpZones: string;
  helpJump: string;
  portfolioLabel: string;
  portfolioLead: string;
  edgeLabel: string;
  edgeLead: string;
  status: string;
  copyright: string;
  langAria: string;
  themeAria: string;
  navHome: string;
  navLibrary: string;
  navStatus: string;
  navMedia: string;
  libraryTitle: string;
  libraryLede: string;
  statusTitle: string;
  statusLede: string;
  mediaTitle: string;
  mediaLede: string;
  mediaEmpty: string;
  mediaUnconfigured: string;
  overall: string;
  incidents: string;
  noIncidents: string;
  kindEntity: string;
  kindNetwork: string;
}

export interface PortfolioItem {
  id: string;
  kind: "entity" | "network";
  nameEn: string;
  nameZh: string;
  roleEn: string;
  roleZh: string;
  blurbEn: string;
  blurbZh: string;
  href: string | null;
}

/**
 * Single register under DOORPOST — entities + research network together.
 * Short, factual, no personal voice.
 */
export const PORTFOLIO: readonly PortfolioItem[] = [
  {
    id: "cnnrc",
    kind: "entity",
    nameEn: "CNNRC",
    nameZh: "CNNRC",
    roleEn: "Network research",
    roleZh: "网络研究",
    blurbEn: "Interconnection, routing resilience, and observability.",
    blurbZh: "互联、路由韧性与可观测。",
    href: "https://cnnrc.com",
  },
  {
    id: "boorhub",
    kind: "entity",
    nameEn: "Boorhub",
    nameZh: "Boorhub",
    roleEn: "Technology",
    roleZh: "技术",
    blurbEn: "Data science, analytics, machine learning, and security.",
    blurbZh: "数据科学、分析、机器学习与安全。",
    href: "https://boorhub.com",
  },
  {
    id: "as133555",
    kind: "network",
    nameEn: "AS133555",
    nameZh: "AS133555",
    roleEn: "Research network",
    roleZh: "研究网络",
    blurbEn: "Autonomous system for experimentation on the public Internet.",
    blurbZh: "面向公众互联网试验的自治系统。",
    href: "https://www.peeringdb.com/asn/133555",
  },
] as const;

/** @deprecated */
export const COMPANIES = PORTFOLIO.filter((p) => p.kind === "entity");
/** @deprecated */
export const UNITS = PORTFOLIO;

export const COPY: Record<Lang, LocaleCopy> = {
  en: {
    title: "DOORPOST",
    headline: "DOORPOST",
    kicker: "International",
    lede: "",
    exploreHint: "WASD move · Drag look · Scroll zoom · Approach zones",
    helpTitle: "Controls",
    helpMove: "WASD / stick — move",
    helpLook: "Drag — look",
    helpZoom: "Scroll — zoom",
    helpZones: "Approach or tap markers",
    helpJump: "Space — jump",
    portfolioLabel: "Under this roof",
    portfolioLead: "",
    edgeLabel: "This edge",
    edgeLead: "",
    status: "Status",
    copyright: "© DOORPOST International",
    langAria: "Switch language",
    themeAria: "Toggle color theme",
    navHome: "Home",
    navLibrary: "Library",
    navStatus: "Status",
    navMedia: "Media",
    libraryTitle: "Library",
    libraryLede: "Selected notes.",
    statusTitle: "Status",
    statusLede: "Availability across services.",
    mediaTitle: "Media",
    mediaLede: "Shared media.",
    mediaEmpty: "Nothing published here yet.",
    mediaUnconfigured: "Media storage is not configured.",
    overall: "Overall",
    incidents: "Incidents",
    noIncidents: "No open incidents.",
    kindEntity: "Entity",
    kindNetwork: "Network",
  },
  zh: {
    title: "DOORPOST",
    headline: "DOORPOST",
    kicker: "International",
    lede: "",
    exploreHint: "WASD 移动 · 拖拽视角 · 滚轮缩放 · 靠近区域",
    helpTitle: "操作",
    helpMove: "WASD / 摇杆 — 移动",
    helpLook: "拖拽 — 视角",
    helpZoom: "滚轮 — 缩放",
    helpZones: "靠近或点击标记",
    helpJump: "空格 — 跳跃",
    portfolioLabel: "名下",
    portfolioLead: "",
    edgeLabel: "此边缘",
    edgeLead: "",
    status: "状态",
    copyright: "© DOORPOST International",
    langAria: "切换语言",
    themeAria: "切换明暗主题",
    navHome: "首页",
    navLibrary: "文库",
    navStatus: "状态",
    navMedia: "媒体",
    libraryTitle: "文库",
    libraryLede: "选录札记。",
    statusTitle: "状态",
    statusLede: "服务可用性。",
    mediaTitle: "媒体",
    mediaLede: "共享媒体。",
    mediaEmpty: "暂无内容。",
    mediaUnconfigured: "未配置媒体存储。",
    overall: "总览",
    incidents: "事件",
    noIncidents: "暂无进行中的事件。",
    kindEntity: "实体",
    kindNetwork: "网络",
  },
};

export const STORAGE_LANG = "doorpost.lang";
export const STORAGE_THEME = "doorpost.theme";
